import { PriceConverter } from '../../helpers'
import { FormattedMessage } from 'react-intl'

export default function PriceSection({
  occupancy,
  currency,
  product,
  isApplySingle,
}) {
  const price = {
    current: isApplySingle ? product.items[0].priceNet : occupancy?.priceNet,
    modified: isApplySingle ? occupancy?.priceNet : product.items[0].priceNet,
  }
  return (
    <div className='price-block'>
      <span className='new-price'>
        {<PriceConverter amount={price.current} currency={currency} />}
      </span>
      <span className='old-price'>
        (<FormattedMessage id='instead_of' defaultMessage='instead of' />
        &nbsp;
        <PriceConverter amount={price.modified} currency={currency} />)
      </span>
    </div>
  )
}
